export default __webpack_public_path__ + "static/media/confetti.12609522.svg";